import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  set(name: string, value: any, expiration: number | null = 7): void {
    let cookieString = `${name}=${value};path=/`;

    if (expiration !== null) {
      const d = new Date();
      d.setTime(d.getTime() + expiration * 24 * 3600 * 1000);
      cookieString += `;expires=${d.toUTCString()}`;
    }

    document.cookie = cookieString;
  }


  get(name: string): any {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const nameValue = cookie.trim().split('=');
      if (name === nameValue[0]) {
        if (nameValue.length > 1) {
          return nameValue[1];
        } else {
          return null;
        }
      }
    }

    return null;
  }

  remove(name: string): void {
    const d = new Date();
    d.setTime(0);
    document.cookie = name + '=;expires=' + d.toUTCString() + ';path=/';
  }
}
